import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '🔁',
    title: 'pages.quizOnboarding.triedBefore.answer1',
    value: 'multiple_times',
  },
  {
    emoji: '🙋',
    title: 'pages.quizOnboarding.triedBefore.answer2',
    value: 'once_stopped',
  },
  {
    emoji: '👀',
    title: 'pages.quizOnboarding.triedBefore.answer3',
    value: 'dabbled',
  },
  {
    emoji: '🆕',
    title: 'pages.quizOnboarding.triedBefore.answer4',
    value: 'first_time',
  },
]

export default function TriedBeforePage() {
  const language = useSelectedLanguageName()

  return (
    <QuizChoicePage
      answers={answers}
      title="pages.quizOnboarding.triedBefore.title"
      translationInterpolation={{ language }}
    />
  )
}
